import { useContext, useMemo, useCallback } from 'react';
import { CheckboxGroupContext } from './context.es.js';

/**
 * Checkbox group context hook.
 */ const useCheckboxGroupContext = (props)=>{
    const context = useContext(CheckboxGroupContext);
    // Determine checked state if context is available
    const checked = useMemo(()=>context?.isChecked(props.value) ?? props.checked, [
        context,
        props.checked,
        props.value
    ]);
    // Determine disabled state if context is available
    const disabled = useMemo(()=>context?.disabled ?? props.disabled, [
        context,
        props.disabled
    ]);
    // Determine onChange if context is available
    const onChange = useCallback((ev)=>{
        context?.deriveOnChange(ev, props.value);
        props.onChange?.(ev);
    }, [
        context,
        props
    ]);
    return {
        checked,
        disabled,
        onChange
    };
};

export { useCheckboxGroupContext };
//# sourceMappingURL=index.es.js.map
